import { z } from 'zod';

export const addGroupSchema = z.object({
  name: z.string().min(1),
  groupType: z.string().optional(),
});
